@let referencableLayers = referencableLayers$ | async;
@if (referencableLayers) {
  <mat-form-field appearance="fill">
    <mat-label i18n="@@core.filter.select-layer-to-use-as-filter">Select layer to use as filter</mat-label>
    <mat-select [formControl]="referenceLayerControl">
      <mat-option [value]="undefined" i18n="@@core.common.none">None</mat-option>
      @for (layer of referencableLayers; track layer.id) {
        <mat-option [value]="layer.id">{{layer.title}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
